/* LegeKlar – videoer afspilles først, når man trykker – og med lyd. */
(function () {
  var PLAY_ICON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.6v12.8a1 1 0 0 0 1.52.85l10.2-6.4a1 1 0 0 0 0-1.7L9.52 4.75A1 1 0 0 0 8 5.6z"/></svg>';

  function pauseOthers(current) {
    document.querySelectorAll('video').forEach(function (o) {
      if (o !== current && !o.paused && !o.muted) o.pause();
    });
  }

  function setup(root) {
    (root || document).querySelectorAll('.geckio-media video').forEach(function (v) {
      var box = v.closest('.geckio-media');
      if (!box || box.hasAttribute('data-lk-video')) return;
      // Videoer, som en sektion udtrykkeligt har sat til autoplay, får lov at være.
      if (box.querySelector('[data-geckio-video][data-autoplay="true"]')) return;
      box.setAttribute('data-lk-video', '');
      box.classList.add('lk-vplay-wrap');
      v.autoplay = false;
      v.removeAttribute('autoplay');
      v.muted = false;
      v.removeAttribute('muted');
      v.controls = false;
      v.setAttribute('playsinline', '');
      if (!v.getAttribute('preload') || v.getAttribute('preload') === 'auto') v.setAttribute('preload', 'metadata');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lk-vplay';
      btn.setAttribute('aria-label', 'Afspil video med lyd');
      btn.innerHTML = PLAY_ICON;
      var label = document.createElement('span');
      label.className = 'lk-vplay__label';
      label.setAttribute('aria-hidden', 'true');
      label.textContent = '🔊 Med lyd';
      box.appendChild(btn);
      box.appendChild(label);

      btn.addEventListener('click', function () {
        v.muted = false;
        v.controls = true;
        box.classList.add('is-playing');
        pauseOthers(v);
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () { box.classList.remove('is-playing'); });
      });
      v.addEventListener('play', function () { box.classList.add('is-playing'); pauseOthers(v); });
      v.addEventListener('ended', function () {
        box.classList.remove('is-playing');
        v.controls = false;
        v.load();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
